export default {
  type: "类型", // value:数值轴  category:类目轴  time:时间轴  log:对数轴
  data: "类目数据",
  "axisLine.show": "显示轴线",
  "axisLine.lineStyle.color": "线颜色",
  "axisLine.lineStyle.type": "线类型", // solid dashed dotted
  "axisLine.lineStyle.width": "线线宽",
  "axisLabel.padding": "文字块内边距", // 【上，右，下，左】
  "axisLabel.interval": "文字间距",
  "axisLabel.show": "显示刻度标签",
  "axisLabel.color": "刻度标签字色",
  "axisLabel.fontFamily": "标签字体",
  "axisLabel.fontWeight": "标签字重",
  "axisLabel.fontSize": "标签文字大小",
  "axisLabel.rotate": "标签旋转角度",
  "axisLabel.borderRadius": "标签文字圆角",
  "axisLabel.margin": "刻度标签边距",
  "axisLabel.backgroundColor": "文字背景色",
  "splitLine.show": "显示分割线",
  "splitLine.lineStyle.color": "分割线颜色",
  "splitLine.lineStyle.type": "分割线类型",
  "splitLine.lineStyle.width": "分割线线宽",
  inverse: "是否是反向轴",
  name: "名称",
  nameLocation: "名称显示位置",
  "nameTextStyle.color": "名称的颜色",
  "nameTextStyle.fontFamily": "名称字体",
  "nameTextStyle.fontWeight": "名称字重",
  "nameTextStyle.fontSize": "名称字号",
  "nameTextStyle.padding": "名称内边距",
  dataValueLengthControl: "限制文字长度",
  dataValueLength: "文字长度",
  show: "显示轴"
}
